<template>
  <div>
    <ul class="item">
      <li class="boxcolor">
        <div style="width: 30%"></div>
        <div class="cjtTitle">关注用户</div>
        <div class="cjtTitle">活跃用户</div>
        <div class="cjtTitle">民意收集</div>
      </li>
    </ul>
    <ul class="item">
      <li class="boxcolor1">
        <div class="box2">全县</div>
        <div class="box1">{{ numSum }}</div>
        <div class="box1">{{ activeNumSum }}</div>
        <div class="box1">{{ feedbackNumSum }}</div>
      </li>
    </ul>
    <vue-seamless-scroll
      :data="listData"
      :class-option="classOption"
      class="seamless-warp"
    >
      <ul class="item">
        <li
          v-for="(item, index) in listData"
          :key="index"
          :style="{ backgroundColor: index % 2 == 0 ? '#345A52' : '' }"
        >
          <div class="box2">{{ item.town }}</div>
          <div class="box1">{{ item.num }}</div>
          <div class="box1">{{ item.activeNum }}</div>
          <div class="box1">{{ item.feedbackNum }}</div>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [],
      numSum: 0,
      activeNumSum: 0,
      feedbackNumSum: 0,
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: 1, //开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2500, //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var data_num = plOtherDataInterface.getVillagerAndFeedbackNum();
      this.listData = data_num.villagerStatisList;
      this.listData.push({
        town: "平罗县",
        num: data_num.numSum,
        activeNum: data_num.activeNumSum,
        feedbackNum: data_num.feedbackNumSum,
      });
      this.activeNumSum = data_num.activeNumSum;
      this.numSum = data_num.numSum;
      this.feedbackNumSum = data_num.feedbackNumSum;
    },
  },
};
</script>
<style scoped>
.cjtTitle {
  color: #ffffff;
}
.seamless-warp {
  width: 100%;
  height: 24vh;
  overflow: hidden;
}
.item li {
  display: flex;
  justify-content: space-around;
}
.boxcolor {
  background: url("../../assets/images/cjtBackgrond.png");
  font-size: 14px;
}
.boxcolor1 {
  color: aquamarine;
}
.boxcolor2 {
  background-color:rgb(16,72,83,0.61);
}
li .box2 {
  width: 35%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
li .box1 {
  width: 20%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/rightAside/rightAside2.vue